export interface SelectionItem {
  id: number | string;
  name: string;
  icon?: string;
  link?: string | number;
  isActive?: boolean;
}
